import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

export default function BadgeWithIcon({
  Icon,
  children,
  iconSize = 30,
  fontSize = 12,
  color = '#be1622',
  backgroundColor = 'white',
  labelPaddingLeft = 6,
  boxShadowSize = [{ color: '#be1622', size: 2 }],
  imageBoxShadowSize = [{ color: '#be1622', size: 2 }],
}) {
  const containerSize = Math.round((iconSize * 5) / 6);

  return (
    <BadgeContainer>
      <IconContainer
        $size={containerSize}
        $boxShadowSize={imageBoxShadowSize}
        $backgroundColor={backgroundColor}
      >
        {Icon}
      </IconContainer>
      {children && (
        <Label
          $paddingLeft={Math.round(iconSize / 2) + labelPaddingLeft}
          $marginLeft={-Math.round(iconSize / 2)}
          $fontSize={fontSize}
          $color={color}
          $borderRadius={fontSize}
          $boxShadowSize={boxShadowSize}
          $backgroundColor={backgroundColor}
        >
          {children}
        </Label>
      )}
    </BadgeContainer>
  );
}

BadgeWithIcon.propTypes = {
  Icon: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  iconSize: PropTypes.number,
  fontSize: PropTypes.number,
  color: PropTypes.string,
  labelPaddingLeft: PropTypes.number,
  boxShadowSize: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string.isRequired,
      size: PropTypes.number.isRequired,
    }),
  ),
  imageBoxShadowSize: PropTypes.arrayOf(
    PropTypes.shape({
      color: PropTypes.string.isRequired,
      size: PropTypes.number.isRequired,
    }),
  ),
};

const BadgeContainer = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  z-index: 1;
`;

const Label = styled.div`
  margin-left: ${({ $marginLeft }) => $marginLeft}px;
  padding: 1px 6px 1px ${({ $paddingLeft }) => $paddingLeft}px;
  font-size: ${({ $fontSize }) => $fontSize}px;
  font-weight: 600;
  text-transform: uppercase;
  color: ${({ $color }) => $color};
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  box-shadow: ${({ $boxShadowSize }) =>
    $boxShadowSize.map(({ color, size }) => `0 0 0 ${size}px ${color}`).join(', ')};
  border-radius: 0 ${({ $borderRadius }) => $borderRadius}px
    ${({ $borderRadius }) => $borderRadius}px 0;
  user-select: none;
`;

const IconContainer = styled.div`
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  box-shadow: ${({ $boxShadowSize }) =>
    $boxShadowSize.map(({ color, size }) => `0 0 0 ${size}px ${color}`).join(', ')};
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  z-index: 1;
`;
